import React, { createContext, useContext, ReactNode } from 'react';
import { ITemplateData } from '@/services/template-data-service';

interface TemplateDataContextType {
  templateData: ITemplateData | null;
  isLoaded: boolean;
}

const TemplateDataContext = createContext<TemplateDataContextType>({
  templateData: null,
  isLoaded: false
});

interface TemplateDataProviderProps {
  children: ReactNode;
  templateData: ITemplateData | null;
}

export const TemplateDataProvider = ({ children, templateData }: TemplateDataProviderProps) => {
  const value = {
    templateData,
    isLoaded: !!templateData
  };

  return <TemplateDataContext.Provider value={value}>{children}</TemplateDataContext.Provider>;
};

export const useTemplateData = (): TemplateDataContextType => {
  const context = useContext(TemplateDataContext);
  if (!context) {
    throw new Error('useTemplateData must be used within a TemplateDataProvider');
  }
  return context;
};

// Safe hook that returns null if not initialized or context not available
export const useTemplateDataSafe = (): ITemplateData | null => {
  try {
    const context = useContext(TemplateDataContext);
    return context?.templateData || null;
  } catch (error) {
    return null;
  }
};
